// @ts-strict-ignore
import mixpanel from 'lib/analytics/mixpanel';
import { useDidMount } from 'lib/hooks/useDidMount';
import storage from 'local-storage-fallback';
import { useEffect, useRef, type JSX } from 'react';

import { TalkActionButton } from 'components/pages/talks/TalkActionButton';
import useVideoPlayerStore from 'components/video-player-dubbing/store';
import { isEmpty } from 'lodash-es';

type LikeProps = {
  id: string;
  viewedCount: number;
};

const Like = ({ id }: LikeProps): JSX.Element => {
  const isMounted = useDidMount();

  const isTalkLiked = storage.getItem(id);

  const liked = isTalkLiked === 'true';

  const buttonRef = useRef(undefined);
  const { onLike } = useVideoPlayerStore(state => ({
    onLike: state.onLike
  }));

  useEffect(() => {
    if (isMounted) {
      if (isEmpty(isTalkLiked)) {
        storage.setItem(id, 'false');
      }
    }
  }, [isMounted]);

  const handleClick = () => {
    if (isTalkLiked === 'true') {
      mixpanel.track('component_click', {
        like_value: false,
        component: 'Dubbing Like Button'
      });
      storage.setItem(id, 'false');
    } else {
      mixpanel.track('component_click', {
        like_value: true,
        component: 'Dubbing Like Button'
      });
      storage.setItem(id, 'true');
    }

    onLike();
  };

  return (
    <TalkActionButton
      ref={buttonRef}
      testId="LikeActionButton_TESTID"
      iconName={liked ? 'heart-filled' : 'heart'}
      onClick={handleClick}
      label={liked ? 'Liked' : 'Like'}
    />
  );
};

export default Like;
